import { IOption } from '../typings'

/**
 * Selected filter options are persisted as `{ value, label }` snapshots, so an
 * entity renamed after it was selected keeps rendering its old name. Prefer the
 * label from the freshly loaded item list, falling back to the stored one when
 * the item is not in the list (a filtered subset, or a deleted record).
 *
 * Returns the original array when nothing is stale so callers keep referential
 * equality.
 */
export function resolveOptionLabels(
  selected: IOption[],
  items: IOption[],
): IOption[] {
  if (selected.length === 0 || items.length === 0) return selected

  let changed = false

  const next = selected.map((option) => {
    const item = items.find((x) => String(x.value) === String(option.value))
    if (!item || item.label === option.label) return option

    changed = true
    return { ...option, label: item.label }
  })

  return changed ? next : selected
}
